import { useState } from 'react';

import BlockTitle from '../../../components/Text/BlockTitle';
import BlockText from '../../../components/Text/BlockText';
import ActionButton from '../../../components/Buttons/ActionButton';
import TextInput from '../../../components/Inputs/TextInput';
import TextAreaInput from '../../../components/Inputs/TextAreaInput';

import './EmailSettings.css';

import axios from 'axios';

function EmailSettings(props) {

    const [estimateEmailEditMode, setEstimateEmailEditMode] = useState(false);
    const [tempEstimateEmailSubject, setTempEstimateEmailSubject] = useState('');
    const [tempEstimateEmailBody, setTempEstimateEmailBody] = useState('');

    const [collectionEmailEditMode, setCollectionEmailEditMode] = useState(false);
    const [tempCollectionEmailSubject, setTempCollectionEmailSubject] = useState('');
    const [tempCollectionEmailBody, setTempCollectionEmailBody] = useState('');

    const toggleEditEstimatEmail = () => {
        setEstimateEmailEditMode(!estimateEmailEditMode);
        if (estimateEmailEditMode) {
            setTempEstimateEmailSubject('');
            setTempEstimateEmailBody('');
        }
        else {
            setTempEstimateEmailSubject(props.emails[0].subject);
            setTempEstimateEmailBody(props.emails[0].body);
        }
    }

    const saveEstimateEmail = () => {

        axios.put('/api/settings/updateEstimateEmail',
            {subject: tempEstimateEmailSubject, body: tempEstimateEmailBody})
            .catch(error => console.log(error));

        props.updateEmails([{id: 1, subject: tempEstimateEmailSubject, body: tempEstimateEmailBody}, ...props.emails.slice(1)])
        toggleEditEstimatEmail();
    }

    const toggleEditCollectionEmail = () => {
        setCollectionEmailEditMode(!collectionEmailEditMode);
        if (collectionEmailEditMode) {
            setTempCollectionEmailSubject('');
            setTempCollectionEmailBody('');
        }
        else {
            setTempCollectionEmailSubject(props.emails[1].subject);
            setTempCollectionEmailBody(props.emails[1].body);
        }
    }

    const saveCollectionEmail = () => {

        axios.put('/api/settings/updateCollectionEmail',
            {subject: tempCollectionEmailSubject, body: tempCollectionEmailBody})
            .catch(error => console.log(error));

        props.updateEmails([props.emails[0], {id: 2, subject: tempCollectionEmailSubject, body: tempCollectionEmailBody}, ...props.emails.slice(2)])
        toggleEditCollectionEmail();
    }

    return (
        <div className='EmailSettings'>

            <div className='estimate-email'>
                <BlockTitle>Repair Estimate Email</BlockTitle>
                <BlockText>Email sent with estimate attached.</BlockText>

                {estimateEmailEditMode ?
                <>
                <div className='email-content'>
                    <TextInput value={tempEstimateEmailSubject} onChange={setTempEstimateEmailSubject} placeholder='Subject' />
                    <TextAreaInput className='body-input' value={tempEstimateEmailBody} onChange={setTempEstimateEmailBody} placeholder='Email Body' />
                </div>

                <ActionButton className='cancel-button' onClick={toggleEditEstimatEmail}>Cancel</ActionButton>
                <ActionButton className='save-button' colored='true' onClick={saveEstimateEmail}>Save</ActionButton>
                </>
                :
                <>
                <div className='email-content'>
                    <BlockText><span>Subject: </span>{props.emails[0].subject}</BlockText>
                    <BlockText>{props.emails[0].body}</BlockText>
                </div>

                <ActionButton className='edit-button' onClick={toggleEditEstimatEmail}>Edit</ActionButton>
                </>
                }
            </div>

            <div className='collection-email'>
                <BlockTitle>Collection Email</BlockTitle>
                <BlockText>Email sent when repair is complete and instrument is ready to collect.</BlockText>

                {collectionEmailEditMode ?
                <>
                <div className='email-content'>
                    <TextInput value={tempCollectionEmailSubject} onChange={setTempCollectionEmailSubject} placeholder='Subject' />
                    <TextAreaInput className='body-input' value={tempCollectionEmailBody} onChange={setTempCollectionEmailBody} placeholder='Email Body' />
                </div>

                <ActionButton className='cancel-button' onClick={toggleEditCollectionEmail}>Cancel</ActionButton>
                <ActionButton className='save-button' colored='true' onClick={saveCollectionEmail}>Save</ActionButton>
                </>
                :
                <>
                <div className='email-content'>
                    <BlockText><span>Subject: </span>{props.emails[1].subject}</BlockText>
                    <BlockText>{props.emails[1].body}</BlockText>
                </div>

                <ActionButton className='edit-button' onClick={toggleEditCollectionEmail}>Edit</ActionButton>
                </>
                }
            </div>

        </div>
    );
}

export default EmailSettings;